import React, { useContext } from 'react';
import { CommunityDragonContext } from '../providers/CommunityDragonProvider';
import { Bar } from 'react-chartjs-2';
import { Team } from '../types/snapshot/Enums';
var WinrateContributionChartMini = function (_a) {
    var playerTeam = _a.playerTeam, allyRoles = _a.allyRoles, winrateContributions = _a.winrateContributions, iconDim = _a.iconDim;
    var championSummary = useContext(CommunityDragonContext).championSummary;
    if (!playerTeam || !allyRoles) {
        return null;
    }
    var orderedChampionNames = [allyRoles.top, allyRoles.jungle, allyRoles.mid, allyRoles.bot, allyRoles.support];
    var labels = orderedChampionNames.map(function (championName, i) {
        var _a, _b, _c;
        var icon;
        if (championSummary && championSummary.length) {
            var id = (_a = championSummary.find(function (champion) { return champion.alias.toLowerCase() === championName; })) === null || _a === void 0 ? void 0 : _a.id;
            icon = id ? "https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/".concat(id, ".png") : championName;
        }
        else {
            icon = championName;
        }
        var teamName = i < 5 ? playerTeam : Team.getOpposite(playerTeam);
        ;
        var properChampionName = (_c = (_b = championSummary === null || championSummary === void 0 ? void 0 : championSummary.find(function (champion) { return champion.alias.toLowerCase() === championName; })) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : championName;
        return { icon: icon, team: teamName, championName: properChampionName };
    });
    var trueData = orderedChampionNames.map(function (championName) { return winrateContributions[championName].overall; });
    var data = trueData.map(function (val) { return Math.abs(val); });
    var chartData = {
        labels: labels,
        datasets: [{
                data: data,
                backgroundColor: orderedChampionNames.map(function (championName, i) {
                    return winrateContributions[championName].overall >= 0 ? 'rgba(0, 194, 3, 0.5)' : 'rgba(194, 2, 2, 0.5)';
                }),
                borderColor: orderedChampionNames.map(function (championName, i) {
                    return winrateContributions[championName].overall >= 0 ? 'rgba(0, 194, 3, 1)' : 'rgba(194, 2, 2, 1)';
                }),
                borderWidth: 2,
                borderRadius: {
                    topRight: 3,
                    bottomRight: 3,
                },
            }]
    };
    var options = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        responsive: true,
        layout: {
            padding: {
                left: 25,
            }
        },
        scales: {
            x: {
                position: 'top',
                beginAtZero: true,
                min: 0,
                ticks: {
                    color: '#FFFFFF',
                    font: {
                        size: 10,
                    },
                    padding: 0,
                    callback: function (value, index, values) {
                        return "".concat(value, "%");
                    },
                },
                title: {
                    display: false,
                },
                grid: {
                    display: false,
                },
                border: {
                    display: true,
                    color: 'white',
                    width: 1,
                }
            },
            y: {
                ticks: {
                    callback: function (value) {
                    },
                },
                grid: {
                    display: false,
                },
                border: {
                    display: true,
                    color: 'white',
                    width: 1,
                }
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    title: function (tooltipItems) {
                        var item = tooltipItems[0];
                        var label = item.chart.data.labels[item.dataIndex];
                        if (label && label.championName) {
                            return label.championName;
                        }
                        return '';
                    },
                    label: function (context) {
                        var allyTeam = context.dataIndex < 5;
                        var trueValue = trueData[context.dataIndex];
                        var value = allyTeam ? trueValue : -trueValue;
                        return " ".concat(value.toFixed(2), "%");
                    }
                }
            },
            crosshair: false,
            zoom: false,
            lineChartIcons: {
                enabled: false,
            },
            barChartLabelIcons: {
                enabled: false,
            },
            barChartMiniLabelIcons: {
                enabled: true,
                iconDim: iconDim,
            },
        },
    };
    return (React.createElement("div", { style: { width: '100%', height: '100%' } },
        React.createElement(Bar, { data: chartData, options: options })));
};
export default WinrateContributionChartMini;
